import { cn } from '@latitude/token-utils';

/**
 * Shared TriggerInput classNames for both sync and async Select.
 */
export const getTriggerInputClassNames = (
  disabled: boolean | undefined,
  inputClassName: string | undefined,
  contentWrapper?: string,
) => ({
  wrapper: cn(
    {
      'w-full': true,
      'cursor-not-allowed': disabled,
      'cursor-pointer': !disabled,
      'before:group-focus:border-color-comp-text-field-border-selected': true,
    },
    inputClassName,
  ),
  ...(contentWrapper !== undefined ? { contentWrapper } : {}),
  input: cn({
    'cursor-not-allowed': disabled,
    'cursor-pointer': !disabled,
  }),
});
